import { ITEMS_PER_PAGE } from 'core/constants/platform.constants';
import { EApplications } from 'core/model/enums';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../constants';
import type { IBannersState } from '../types';

export const fetchVisualizationTabBanners = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/fetchVisualizationTabBanners`,
  async (platform: EApplications, { getState, rejectWithValue }) => {
    try {
      const { banners } = getState();

      const {
        branchIdList,
        priceListIdList,
        pagination: { currentPage },
      } = banners.visualizationTab[platform];

      return await apiService.banners.getBannerCarouselList({
        page: currentPage,
        itemsPerPage: ITEMS_PER_PAGE,
        priceListIds: priceListIdList,
        branches: branchIdList,
      });
    } catch (error) {
      const errorMessage = handleErrorMessage(error, 'Falló al cargar los banners de la pestaña de visualización.');

      notificationService.global.error(errorMessage);

      return rejectWithValue(error);
    }
  },
);

export const fetchVisualizationTabBannersReducer: TSliceExtraReducer<IBannersState> = builder =>
  builder
    .addCase(fetchVisualizationTabBanners.pending, (state, action) => {
      const platform = action.meta.arg;

      state.visualizationTab[platform].loading = true;
    })
    .addCase(fetchVisualizationTabBanners.rejected, (state, action) => {
      const platform = action.meta.arg;

      state.visualizationTab[platform].loading = false;

      state.visualizationTab[platform].banners = [];
    })
    .addCase(fetchVisualizationTabBanners.fulfilled, (state, action) => {
      const platform = action.meta.arg;

      state.visualizationTab[platform].loading = false;

      state.visualizationTab[platform].banners = action.payload.segmentedBanners;

      state.visualizationTab[platform].pagination = action.payload.pagination;
    });
